import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=c899c616&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c899c616')) {
      api.createRecord('c899c616', component.options)
    } else {
      api.reload('c899c616', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=c899c616&", function () {
      api.rerender('c899c616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21QE22aZ8kDkx/JS/offershelp.vue"
export default component.exports